import React, { useEffect, useState } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { Col, FormGroup, Label, Row, Modal, ModalHeader, ModalBody, Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import './datePickerStyle.scss'

import { setCampaignData } from 'redux/actions/marketing'
import { lang } from 'utils/helpers'

const Step4 = () => {
  const dispatch = useDispatch()

  const [releaseDate, setReleaseDate] = useState('')
  const [releaseTime, setReleaseTime] = useState('')
  const [facebookUsersExist, setFacebookUsersExist] = useState(false)
  const [minDate, setMinDate] = useState('')
  const [showFbModal, setShowFbModal] = useState(false)

  useEffect(() => {
    setStartDate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [releaseDate, releaseTime])

  const campaign = useSelector((state) => state.marketing.campaign)

  useEffect(() => {
    // check if there are facebook users 
    const fbUsers = campaign.usersByChannel.find(el => el.channel === 'facebook')
    if(fbUsers && fbUsers.usersQuantity > 0) {
      setFacebookUsersExist(true)
      const minDate = moment().add(2, 'days')
      setMinDate(minDate)
    }

    return () => {
      setFacebookUsersExist(false)
      setMinDate('')
    }

  }, [])

  const toggleModal = () => setShowFbModal(show => !show)

  const handleDateChange = (date) => {
    if(date < minDate) {
      setShowFbModal(true)
      return
    }

    setReleaseDate(date)
  }

  const handleTimeChange = (date) => {
    setReleaseTime(date)
  }

  const getEndDate = (date) => {
    const { duration, durationLabel } = campaign
    const endDate = moment(date).add(duration, durationLabel).endOf('day')
    return endDate
  }

  const setStartDate = () => {
    let startDateText = moment().format('YYYY-MM-DD')
    let hoursText = '00:00:00'

    if (releaseTime) {
      hoursText = moment(releaseTime).format('HH:mm:ss')
    }

    if (releaseDate) {
      startDateText = moment(releaseDate).format('YYYY-MM-DD')
    }

    const startDt = moment(`${startDateText} ${hoursText}`).toDate()
    const endDate = getEndDate(startDt)

    dispatch(
      setCampaignData({
        ...campaign,
        startDate: moment(startDt).format(),
        endDate: moment(endDate).format(),
        launchDate: moment(startDt).format(),
      })
    )
  }

  return (
    <>
      <h1>{I18n.t('campaign_step_launch_campaign')}</h1>
      <p></p>

      <Row className='mt-2 mb-3'>
        <Col xs={12}>
          <h4>{I18n.t('dashboard_summary')}</h4>
        </Col>
      </Row>
      <Row>
        <Col xs={4}>
          <div className='summary-box'>
            <p className='heading'>{I18n.t('dashboard_campaign')}</p>
            <p className='title'>{campaign.name}</p>
            <p className='sub-title'>{`${I18n.t('dashboard_duration')} ${campaign.duration} ${lang(campaign.durationLabel)}`}</p>
          </div>
        </Col>
        <Col xs={4}>
          <div className='summary-box'>
            <p className='heading'>{I18n.t('dashboard_recipients')}</p>
            <Row>
              <Col xs={6}>
                <p className='title-number'>{campaign.totalUsers}</p>
                <p className='sub-title light'> {I18n.t('dashboard_users')}</p>
              </Col>
              <Col xs={6}>
                <p className='title-number'>{campaign.usersByChannel.length}</p>
                <p className='sub-title light'>{I18n.t('dashboard_channels')}</p>
              </Col>
            </Row>
          </div>
        </Col>
        <Col xs={4}>
          <div className='summary-box'>
            <p className='heading'>{I18n.t('dashboard_messages')}</p>
            <ul>
              {campaign.usersByChannel.map((iCh) => (
                <li key={iCh.channel}>
                  <i className='fa fa-check'></i>
                  {I18n.t(`channels_${iCh.channel}`)} {iCh.usersQuantity} {I18n.t('dashboard_users')}
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>
      <Row className='mt-4 mb-3'>
        <Col xs={3}>
          <FormGroup>
            <Label> {I18n.t('dashboard_release-date')}</Label>
            <div className='div-date-step4'>
              { facebookUsersExist && (
                <DatePicker
                  dateFormat='dd/MM/yyyy'
                  className='form-control text-center date-step4'
                  selected={releaseDate}
                  onChange={(date) => handleDateChange(date)}
                  dayClassName={date => date < minDate ? 'grey' : ''}
                // highlightDates={[new Date(), minDate]}
                />
              ) }
              { !facebookUsersExist && (
                <DatePicker
                  dateFormat='dd/MM/yyyy'
                  className='form-control text-center date-step4'
                  selected={releaseDate}
                  onChange={(date) => handleDateChange(date)}
                />
              ) }
            </div>
          </FormGroup>
        </Col>

        <Col xs={3}>
          <FormGroup>
            <Label for='cost'>{I18n.t('dashboard_hour')}</Label>
            <div className='div-time-step4'>
              <DatePicker
                className='form-control text-center time-step4'
                showTimeSelect
                showTimeSelectOnly
                timeCaption='Time'
                dateFormat='HH:mm'
                timeFormat='HH:mm'
                selected={releaseTime}
                onChange={(date) => handleTimeChange(date)}
              />
            </div>
          </FormGroup>
        </Col>
        <Col xs={3}></Col>
      </Row>
      {<Modal isOpen={showFbModal} toggle={toggleModal}>
        <ModalHeader>{I18n.t('campaign_facebook_template_validation')}</ModalHeader> 
        <ModalBody>
          <p>{I18n.t('campaign_facebook_template_validation_text')}</p>
          <Button onClick={toggleModal}
          >Ok</Button>
        </ModalBody>
      </Modal>}
    </>
  )
}

export default connect()(Step4)
